import React from 'react';
import { House, Buildings } from '@phosphor-icons/react';
import { cn, UserRole } from '../../../lib/utils';
interface StepRoleProps {
  value: UserRole | null;
  onChange: (role: UserRole) => void;
}
export function StepRole({
  value,
  onChange
}: StepRoleProps) {
  return <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-1738">
      <div className="text-center" data-id="element-1739">
        <h1 className="text-2xl font-bold text-light-1" data-id="element-1740">
          Cum vrei să folosești Izio?
        </h1>
        <p className="text-sm text-light-3 mt-2" data-id="element-1741">
          Activăm experiența potrivită pentru tine. Poți adăuga al doilea rol
          mai târziu.
        </p>
      </div>

      <div className="space-y-3" data-id="element-1742">
        <RoleCard icon={<House size={28} weight="duotone" data-id="element-1744" />} title="Caut o locuință" subtitle="Sunt chiriaș și vreau să primesc oferte de la proprietari" selected={value === 'demand'} onClick={() => onChange('demand')} data-id="element-1743" />
        <RoleCard icon={<Buildings size={28} weight="duotone" data-id="element-1746" />} title="Am o proprietate de oferit" subtitle="Sunt proprietar sau agent imobiliar și vreau să găsesc chiriași" selected={value === 'supply'} onClick={() => onChange('supply')} data-id="element-1745" />
      </div>

      <p className="text-xs text-light-3 text-center leading-relaxed" data-id="element-1747">
        Vei putea schimba sau adăuga roluri din Setări oricând.
      </p>
    </div>;
}
interface RoleCardProps {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  selected: boolean;
  onClick: () => void;
}
function RoleCard({
  icon,
  title,
  subtitle,
  selected,
  onClick
}: RoleCardProps) {
  return <button type="button" onClick={onClick} className={cn('w-full text-left p-5 rounded-2xl border-2 transition-all duration-200 cursor-pointer', 'flex items-start gap-4', selected ? 'border-lime-1 bg-lime-5' : 'border-dark-3 bg-dark-2 hover:border-dark-4 hover:bg-dark-3/40')} aria-pressed={selected} data-id="element-1748">
      <div className={cn('shrink-0 w-12 h-12 rounded-xl flex items-center justify-center transition-colors', selected ? 'bg-lime-1 text-dark-1' : 'bg-dark-3 text-light-2')} data-id="element-1749">
        {icon}
      </div>
      <div className="flex-1 min-w-0" data-id="element-1750">
        <h3 className="text-base font-semibold text-light-1" data-id="element-1751">{title}</h3>
        <p className="text-sm text-light-3 mt-0.5 leading-relaxed" data-id="element-1752">
          {subtitle}
        </p>
      </div>
    </button>;
}